import Contact from "./Contacts";

export default Contact;
